module.exports = __webpack_public_path__ + "static/radiation-therapist-b80c0bbec475d2096672a1d452b31fd8.jpeg";